/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Matchingdaydate_Label2Inputs */

const en_job_form_matchingdaydate_label2 = /** @type {(inputs: Job_Form_Matchingdaydate_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Day date`)
};

const de_job_form_matchingdaydate_label2 = /** @type {(inputs: Job_Form_Matchingdaydate_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum des Matching Days`)
};

/**
* | output |
* | --- |
* | "Matching Day date" |
*
* @param {Job_Form_Matchingdaydate_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_matchingdaydate_label2 = /** @type {((inputs?: Job_Form_Matchingdaydate_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Matchingdaydate_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_matchingdaydate_label2(inputs)
	return en_job_form_matchingdaydate_label2(inputs)
});
export { job_form_matchingdaydate_label2 as "job_form_matchingDayDate_label" }